import { useAppSelector } from 'app/hooks';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { SubGenre } from 'features/SubGenre/models/SubGenre';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './Add.scss';
import SubGenreFormAdd from './components/SubGenreFormAdd';
interface AddModalInterface {
  show: boolean;
  handleCloseModalAdd?: (status: boolean) => void;
  dataTable?: SubGenre[];
  setDataTable?: (dataTable: SubGenre[] | []) => void;
}

function AddModal({ show, handleCloseModalAdd, dataTable, setDataTable }: AddModalInterface) {
  const { t } = useTranslation();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  function onHide() {
    handleCloseModalAdd && handleCloseModalAdd(false);
  }

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <FeatureTitleBar title={t('SubGenre.Form.title')} />
      </Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <SubGenreFormAdd
          show={show}
          handleCloseModalAdd={handleCloseModalAdd}
          dataTable={dataTable}
          setDataTable={setDataTable}
        />
      </Modal.Body>
    </Modal>
  );
}
export default AddModal;
